<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle32')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle32') }}</h1>
    <p>{{ $t('artText32-1') }}</p>
    <p>{{ $t('artText32-2') }}</p>
    <img
      :src="`${staticUrl}/images/blog/Quest_for_the_Perfect_Home_Design_Solution.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText32-3') }}</h2>
    <p>{{ $t('artText32-4') }}</p>
    <p>{{ $t('artText32-5') }}</p>
    <p>{{ $t('artText32-6') }}</p>
    <h2>{{ $t('artText32-7') }}</h2>
    <p>{{ $t('artText32-8') }}</p>
    <p>{{ $t('artText32-9') }}</p>
    <h2>{{ $t('artText32-10') }}</h2>
    <p>{{ $t('artText32-11') }}</p>
    <p>{{ $t('artText32-12') }}</p>
    <h2>{{ $t('artText32-13') }}</h2>
    <p>{{ $t('artText32-14') }}</p>
    <img
      :src="`${staticUrl}/images/blog/Quest_for_the_Perfect_Home_Design_Solution_1.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText32-15') }}</p>
    <h2>{{ $t('artText32-16') }}</h2>
    <p>{{ $t('artText32-17') }}</p>
    <p>{{ $t('artText32-18') }}</p>
    <h2>{{ $t('artText32-19') }}</h2>
    <p>{{ $t('artText32-20') }}</p>
    <p>{{ $t('artText32-21') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle32')}`,
  ogTitle: `${t('artSeoTitle32')}`,
  description: `${t('artSeoDesc32')}`,
  ogDescription: `${t('artSeoDesc32')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
